export default {
    NOT_STARTED: 'NOT_STARTED',
    AGREEMENT_SENT: 'AGREEMENT_SENT',
    AGREEMENT_ACCEPTED: 'AGREEMENT_ACCEPTED',
    AGREEMENT_REJECTED: 'AGREEMENT_REJECTED',
    AGREEMENT_EXPIRED: 'AGREEMENT_EXPIRED',
    PAID: 'PAID',
    PAYMENT_DELAYED: 'PAYMENT_DELAYED',
    PAYMENT_REVERTED: 'PAYMENT_REVERTED',
    PAYMENT_EXPIRED: 'PAYMENT_EXPIRED',
    ITEM_APPROVED: 'ITEM_APPROVED',
    DISCOUNT_SUGGESTED: 'DISCOUNT_SUGGESTED',
    DISCOUNT_APPROVED: 'DISCOUNT_APPROVED',
};



// WEBPACK FOOTER //
// ./safeTrade/viewStatus.js